import {
  GET_CEREMONY_PROFILE,
  GET_CEREMONY_PROFILE_FAIL,
  GET_CEREMONY_PROFILE_SUCCESS,
  GET_CEREMONIES,
  GET_CEREMONIES_FAIL,
  GET_CEREMONIES_SUCCESS,
  ADD_NEW_CEREMONY,
  ADD_CEREMONY_SUCCESS,
  ADD_CEREMONY_FAIL,
  UPDATE_CEREMONY,
  UPDATE_CEREMONY_SUCCESS,
  UPDATE_CEREMONY_FAIL,
  DELETE_CEREMONY,
  DELETE_CEREMONY_SUCCESS,
  DELETE_CEREMONY_FAIL,
} from "./actionTypes"

export const getCeremonies = ({is_active,offset='',page_size=''}) => ({
  type: GET_CEREMONIES,
  payload:{is_active,offset,page_size}
})

export const getCeremoniesSuccess = ceremonies => ({
  type: GET_CEREMONIES_SUCCESS,
  payload: ceremonies,
})

export const getCeremoniesFail = error => ({
  type: GET_CEREMONIES_FAIL,
  payload: error,
})

export const addNewCeremony = user => ({
  type: ADD_NEW_CEREMONY,
  payload: user,
})

export const addCeremonySuccess = user => ({
  type: ADD_CEREMONY_SUCCESS,
  payload: user,
})

export const addCeremonyFail = error => ({
  type: ADD_CEREMONY_FAIL,
  payload: error,
})

export const updateCeremony = user => ({
  type: UPDATE_CEREMONY,
  payload: user,
})

export const updateCeremonySuccess = user => ({
  type: UPDATE_CEREMONY_SUCCESS,
  payload: user,
})

export const updateCeremonyFail = error => ({
  type: UPDATE_CEREMONY_FAIL,
  payload: error,
})

export const deleteCeremony = user => ({
  type: DELETE_CEREMONY,
  payload: user,
})

export const deleteCeremonySuccess = user => ({
  type: DELETE_CEREMONY_SUCCESS,
  payload: user,
})

export const deleteCeremonyFail = error => ({
  type: DELETE_CEREMONY_FAIL,
  payload: error,
})

export const getCeremonyProfile = () => ({
  type: GET_CEREMONY_PROFILE,
})

export const getCeremonyProfileSuccess = userProfile => ({
  type: GET_CEREMONY_PROFILE_SUCCESS,
  payload: userProfile,
})

export const getCeremonyProfileFail = error => ({
  type: GET_CEREMONY_PROFILE_FAIL,
  payload: error,
})
